import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import {
  CostCenterService,
  type CostCenterDTO,
} from "@/services/CostCenterService";
import { useToast } from "@/services/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCostCenterDialog',
  props: {
    userId: {},
    userName: {}
  },
  emits: ["updated"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const dialog = ref(false);
const costCenterService = new CostCenterService();
const { showToast } = useToast();

const allCostCenters = ref<CostCenterDTO[]>([]);
const selectedIds = ref<number[]>([]);
const loading = ref(false);

const headers = [
  { title: "ID", key: "id", width: "80px" },
  { title: "Név", key: "name" },
];

watch(dialog, async (open) => {
  if (open && props.userId) {
    loading.value = true;
    try {
      const [all, assigned] = await Promise.all([
        costCenterService.getCompanyCostCenters(),
        costCenterService.getUserCostCenters(props.userId),
      ]);
      allCostCenters.value = all;
      selectedIds.value = assigned.map((cc) => cc.id);
    } catch {
      showToast("Költséghelyek betöltése sikertelen", "error");
    } finally {
      loading.value = false;
    }
  }
});

async function save() {
  if (!props.userId) return;
  try {
    await costCenterService.updateUserCostCenters(
      props.userId,
      selectedIds.value
    );
    dialog.value = false;
    emit("updated");
    showToast("Költséghelyek frissítve");
  } catch {
    showToast("Költséghelyek mentése sikertelen", "error");
  }
}

const __returned__ = { props, emit, dialog, costCenterService, showToast, allCostCenters, selectedIds, loading, headers, save, ref, watch, get CostCenterService() { return CostCenterService }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})